import { motion } from 'framer-motion';

import { Final } from 'js/components';

export default function Page() {
  return (
    <main>
      <motion.div
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1 },
        }}
        initial="hidden"
        animate="visible"
        transition={{ duration: 0.5 }}
      >
        <Final />
      </motion.div>
    </main>
  );
}
